export default __webpack_public_path__ + "static/media/pencil-blue.92753f27.svg";